define(
    'views/user-import',[
        'jquery',
        'utils/view',
        'connections/userimport-connection',
    ],

    function ($, View, UserImportConnection) {
        var UserImportView = (function () {

            function UserImportView() {
                var _this = this;
                _this.init();
            }

            UserImportView.prototype.init = function () {
                $(':checkbox[data-unchecked-dependency]').on('click', function () {
                    var $this = $(this);
                    var $inputs = $($this.data('unchecked-dependency'));

                    if ($this.prop('checked') == false) {
                        $inputs.prop('checked', false);
                    }
                });
                $(':checkbox[data-checked-dependency]').on('click', function () {
                    var $this = $(this);
                    var $inputs = $($this.data('checked-dependency'));

                    if ($this.prop('checked')) {
                        $inputs.prop('checked', true);
                    }
                });

                $('.js-isseller').on('click', function () {
                    if ($(this).prop('checked') == false) {
                        $('#seller-order-types').hide();
                        $('#seller-order-types').find(':checkbox').prop('checked', false);
                    } else {
                        $('#seller-order-types').show();
                    }
                });

                if ($('.js-isseller').prop('checked')) {
                    $('#seller-order-types').show();
                }
            };

            $('.js-check-user-exists').on('change', function () {
                var $this = $(this);

                UserImportConnection.checkUserNotExist($this.val()).then(function (response) {
                    if (!response.success) {
                        $('.js-user-already-exist').show();

                        var $table = $('.user-exists-table');
                        $table.empty();
                        $table.append('<div class="title">' + response.message + '</div>');
                        $table.append('<div class="heading"><div class="cell">Store</div><div class="cell">Customer no</div></div>');
                        Object.keys(response.memberInStores)
                            .forEach(function (key) {
                                var field = response.memberInStores[key];
                                $table.append(
                                    '<div class="row">' +
                                    '<div class="cell">' + field.name + '</div>' +
                                    '<div class="cell">' + field.customerCode + '</div>' +
                                    '</div>');
                            });
                    }
                    else {
                        $('.js-user-already-exist').hide();
                    }
                });
            });

            $('.js-get-company-name').on('change', function () {
                var $this = $(this);

                UserImportConnection.getCompanyName($this.val()).then(function (response) {
                    $('#NewUser_IUCompanyName').val(response.name);
                });
            });

            return UserImportView;
        })();

        return View('UserImport', function () {
            new UserImportView();
        });
    }
);
